"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructFeatureSwitches = void 0;
const react_1 = __importDefault(require("react"));
const createFeatureSwitches_1 = require("./createFeatureSwitches");
const FeatureToggle_1 = require("./FeatureToggle");
const testIds_1 = require("./testIds");
const constructFeatureSwitches = function (featureDefaultsByEnvironment, environmentCheckers, config) {
    const { featureSwitches, updateFeatureSwitchValue, loadFeatureSwitches, updateAllFeatureSwitches, } = createFeatureSwitches_1.createFeatureSwitches(featureDefaultsByEnvironment, environmentCheckers, config);
    loadFeatureSwitches();
    const FeatureToggle = () => {
        if (environmentCheckers.isProduction()) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement(FeatureToggle_1.FeatureToggle, { "data-testid": testIds_1.toggleContainer, featureSwitches: featureSwitches, updateFeatureSwitchValue: updateFeatureSwitchValue, updateAllFeatureSwitches: updateAllFeatureSwitches, featureDefaultsByEnvironment: featureDefaultsByEnvironment }));
    };
    const getFeatureSwitchesAsString = () => {
        const features = Object.entries(featureSwitches).reduce((headers, entry) => {
            const [name, value] = entry;
            headers[name] = value();
            return headers;
        }, {});
        return JSON.stringify(features);
    };
    return {
        featureSwitches,
        getFeatureSwitchesAsString,
        FeatureToggle,
    };
};
exports.constructFeatureSwitches = constructFeatureSwitches;
__exportStar(require("./launchDarkly"), exports);
